<template>
    <div>
        <vs-card class="content_mb-0 mb-4 preview_tab_content">
            <div slot="header">
                <div class="flex flex-wrap items-center">
                    <h4>Class Details - </h4>
                    <h4 class="font-bold">Orchestra Class</h4>
                </div>
            </div>
            <vs-row>
                <vs-col vs-lg="4" vs-sm="12" class="p-2">
                    <img class="w-full" src="https://scoolio-files.s3.ap-south-1.amazonaws.com/Scoolio/Students+watching+webinar+on+computer.jpg" alt="course_image">
                </vs-col>
                <vs-col vs-lg="8" vs-sm="12" class="p-2">
                    <h4 class="mb-4">Class Description</h4>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation</p>
                </vs-col>
            </vs-row>
            <div class="overall_detail_holder">
                <div class="each_data">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 21V19.4C6.43333 19.1333 6.825 18.8375 7.175 18.5125C7.525 18.1875 7.825 17.8417 8.075 17.475C8.325 17.1083 8.51667 16.7167 8.65 16.3C8.78333 15.8833 8.85 15.45 8.85 15C8.85 14.7833 8.8375 14.575 8.8125 14.375C8.7875 14.175 8.75 13.9667 8.7 13.75H6V12.25H7.95C7.3 11.35 6.85417 10.5542 6.6125 9.8625C6.37083 9.17083 6.25 8.46667 6.25 7.75C6.25 6.28333 6.75833 5.04167 7.775 4.025C8.79167 3.00833 10.0333 2.5 11.5 2.5C12.5833 2.5 13.5625 2.77083 14.4375 3.3125C15.3125 3.85417 15.9583 4.58333 16.375 5.5L15 6.075C14.7 5.44167 14.2292 4.9375 13.5875 4.5625C12.9458 4.1875 12.25 4 11.5 4C10.4667 4 9.58333 4.3625 8.85 5.0875C8.11667 5.8125 7.75 6.7 7.75 7.75C7.75 8.4 7.88333 9.0375 8.15 9.6625C8.41667 10.2875 8.95 11.15 9.75 12.25H14V13.75H10.225C10.275 13.9667 10.3083 14.1833 10.325 14.4C10.3417 14.6167 10.35 14.8167 10.35 15C10.35 15.8833 10.1583 16.7083 9.775 17.475C9.39167 18.2417 8.90833 18.9167 8.325 19.5H14C14.6333 19.5 15.1917 19.3333 15.675 19C16.1583 18.6667 16.5083 18.125 16.725 17.375L18.025 18.025C17.8083 19.0083 17.3042 19.75 16.5125 20.25C15.7208 20.75 14.8833 21 14 21H6Z" fill="#555262"/>
                  </svg>
                  <div class="pl-2">
                    <strong>£ 1000</strong>
                    <p>Price</p>
                  </div>
                </div>
                <div class="each_data">
                  <span class="material-icons-outlined">alarm</span>
                  <div class="pl-2">
                    <strong>Not Available</strong>
                    <p>Session Duration</p>
                  </div>
                </div>
                <div class="each_data">
                  <span class="material-icons-outlined">event</span>
                  <div class="pl-2">
                    <strong>Not Available</strong>
                    <p>Number of Sessions</p>
                  </div>
                </div>
                <div class="each_data">
                  <span class="material-icons-outlined">rotate_right</span>
                  <div class="pl-2">
                    <strong>Not Available</strong>
                    <p>Session Frequency</p>
                  </div>
                </div>
                <div class="each_data">
                  <span class="material-icons-outlined">insert_invitation</span>
                  <div class="pl-2">
                    <strong>Not Available</strong>
                    <p>Start Date</p>
                  </div>
                </div>
                <div class="each_data">
                  <span class="material-icons-outlined">insert_invitation</span>
                  <div class="pl-2">
                    <strong>Not Available</strong>
                    <p>End Date</p>
                  </div>
                </div>
                <div class="each_data">
                    <div class="flex items-center">
                        <div class="cstm-img-holder">
                        <vs-tooltip text="User 1" position="top" color="primary">
                            <img src="@/assets/images/pages/user-circle-solid.svg" alt="user-img" width="20" height="20" class="rounded-full shadow-md cursor-pointer block">
                        </vs-tooltip>
                        </div>
                    </div>
                </div>
              </div>
        </vs-card>
        <vs-tabs class="unique_cstm_tab bg_filled_tab_holder">          
            <vs-tab label="Overview">
               <Overview />
            </vs-tab>
            <vs-tab label="Students">
                <Students />
            </vs-tab>
            <vs-tab label="Teachers">
                <Teachers />
            </vs-tab>
            <vs-tab label="Class Curriculum">
                <Curriculum />
            </vs-tab>
            <vs-tab label="Grades">
                <Grades />
            </vs-tab>
            <vs-tab label="Class Settings">
                <Settings />
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>
import Overview from './components/Overview.vue'
import Students from './components/Students.vue'
import Teachers from './components/Teachers.vue'
import Curriculum from './components/Curriculum/index.vue'
import Grades from './components/Grades.vue'
import Settings from './components/Settings/index.vue'

export default {
  name: 'class-details',
  components: {
    Overview,
    Students,
    Teachers,
    Curriculum,
    Grades,
    Settings
  }
}
</script>